(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/* eslint-disable no-undefined */

var throttle = require('./throttle');

/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}  atBegin       Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @return {Function} A new, debounced function.
 */
module.exports = function ( delay, atBegin, callback ) {
	return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
};

},{"./throttle":2}],2:[function(require,module,exports){
/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   noTrailing     Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   debounceMode   If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */
module.exports = function ( delay, noTrailing, callback, debounceMode ) {

	// After wrapper has stopped being called, this timeout ensures that
	// `callback` is executed at the proper times in `throttle` and `end`
	// debounce modes.
	var timeoutID;

	// Keep track of the last time `callback` was executed.
	var lastExec = 0;

	// `noTrailing` defaults to falsy.
	if ( typeof noTrailing !== 'boolean' ) {
		debounceMode = callback;
		callback = noTrailing;
		noTrailing = undefined;
	}

	// The `wrapper` function encapsulates all of the throttling / debouncing
	// functionality and when executed will limit the rate at which `callback`
	// is executed.
	function wrapper () {

		var self = this;
		var elapsed = Number(new Date()) - lastExec;
		var args = arguments;

		// Execute `callback` and update the `lastExec` timestamp.
		function exec () {
			lastExec = Number(new Date());
			callback.apply(self, args);
		}

		// If `debounceMode` is true (at begin) this is used to clear the flag
		// to allow future `callback` executions.
		function clear () {
			timeoutID = undefined;
		}

		if ( debounceMode && !timeoutID ) {
			// Since `wrapper` is being called for the first time and
			// `debounceMode` is true (at begin), execute `callback`.
			exec();
		}

		// Clear any existing timeout.
		if ( timeoutID ) {
			clearTimeout(timeoutID);
		}

		if ( debounceMode === undefined && elapsed > delay ) {
			// In throttle mode, if `delay` time has been exceeded, execute
			// `callback`.
			exec();

		} else if ( noTrailing !== true ) {
			// In trailing throttle mode, since `delay` time has not been
			// exceeded, schedule `callback` to execute `delay` ms after most
			// recent execution.
			//
			// If `debounceMode` is true (at begin), schedule `clear` to execute
			// after `delay` ms.
			//
			// If `debounceMode` is false (at end), schedule `callback` to
			// execute after `delay` ms.
			timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
		}

	}

	// Return the wrapper function.
	return wrapper;

};

},{}],3:[function(require,module,exports){
'use strict';

var debounce = require('throttle-debounce/debounce');

module.exports = function () {
	var pull_url = $('meta[name="url"]').attr("content") + 'clients/case-studies-and-testimonials',

	$sectuin_cst = $('#section-clients-2'),

	$container = $sectuin_cst.find('.case-studies-testimonials-content'),

	$search_form = $sectuin_cst.find('.case-studies-testimonials-search-form'),

	options = $.extend({},{
		id 	   : '',
		limit  : 5
	},$container.data()),

	// total_items = 0,

	current_page = 1,

	number_pages = 1,

	searching = true,
	// owlcarousel, state, 

	$pager_nav = $('<nav class="clearfix">\
		<ul class="pager pull-right">\
			<li class="pages">\
				<a>Page <span class="current-page"></span>/<span class="number-page"></span></a>\
			</li>\
			<li class="control previous">\
				<a href="#">Prev</a>\
			</li>\
			<li class="control next">\
				<a href="#">Next</a>\
			</li>\
		</ul>\
	</nav>'),

	$pager_curr_page = $pager_nav.find('.current-page'),

	$pager_num_page = $pager_nav.find('.number-page');

	function setup () {
		return $.get(pull_url, $.extend({},{
				id 	  : options.id,
				limit : 0
			}, $search_form.serializeObject() )).done(function (datum) {

			// fix bug in firefox
			if( typeof datum === 'string' ) {
				datum = JSON.parse(datum);
			}

			current_page = number_pages = 1; // reset

			if( datum.total > 0 ) {
				number_pages = Math.ceil( datum.total / options['limit'] );
				
				for (var i = 1; i <= number_pages; i++) {
					$container.trigger('add.owl.carousel',['<div class="case-studies-testimonials" data-id="'+i+'" style="transform: translate3d(0,0,0);"></div>']);
				}

				$pager_num_page.html(number_pages);
				$pager_curr_page.html(current_page);
			} else {
				$container.trigger('add.owl.carousel',['<p class="mt-40 h4">NO MATCH FOUND.</p>']);
			}
		});
	}	

	function pull_data() {
		return $.get(pull_url, $.extend({},{
				id : options.id,
				p  : current_page
			}, $search_form.serializeObject() )).done(function(datum){

			// fix bug in firefox
			if( typeof datum === 'string' ) {
				datum = JSON.parse(datum);
			}
			
			if( datum.items !== undefined && datum.items.length ) {
				var $page = $container.find('div[data-id="'+current_page+'"]'), items = '', i;

				for (i = 0; i < datum.items.length; i++) {
					items += datum.items[i];
				}

				$page.append(items);
				$container.trigger('refresh.owl.carousel');		
			}
		});
	}

	function search () {
		$container.removeClass('loaded');
		$pager_nav.hide();
		for (var i = 1; i <= number_pages; i++) {
			$container.trigger('remove.owl.carousel', i);
		}
		$container.trigger('refresh.owl.carousel');	
		setup().done(function(){
			pull_data().done(function(e){
				$container.addClass('loaded');
				if( number_pages > 1 ) {
					$pager_nav.show();
				}
			});
		});
	}

	$container.owlCarousel({
		items     : 1,
		loop      : true,
		mouseDrag : false,
		touchDrag : false,
	}).on('translate.owl.carousel', function() {
		if( current_page > number_pages ) {
			current_page = 1;
		} else if( current_page < 1 ) {
			current_page = number_pages;
		}
		if( $container.find('div[data-id="'+current_page+'"]').html().length === 0 ) {
			pull_data();
		}
		$pager_curr_page.html(current_page);
	});

	setup().done(function(){
		pull_data().done(function(){
			$container.addClass('loaded');
			if( number_pages === 1 ) {
				$pager_nav.hide();
			}
			$container.parent().append($pager_nav);
		});
	});

	$pager_nav.on('click','.pager .next',function(e){
		e.preventDefault();
		current_page++;
		$container.trigger('next.owl.carousel');
	}).on('click','.pager .previous',function(e){
		e.preventDefault();
		current_page--;
		$container.trigger('prev.owl.carousel');
	});

	$search_form.on('input', 'input[name="s"]', debounce(400, search)).on('click','button',function(e){
		e.preventDefault();
		if (e.keyCode !== 10 || e.keyCode !== 13) {
			search();
		}
	});

};

},{"throttle-debounce/debounce":1}],4:[function(require,module,exports){

},{}],5:[function(require,module,exports){
'use strict';

module.exports = function  (argument) {

	$(".month-yr > li").click(function() {
	   $("#menutitle").text($(this).text()); 
	});
};  
},{}],6:[function(require,module,exports){
'use strict';

var whitepapers = require('../custom/whitepapers');

module.exports = function  () {

	// Section 2
	var $section_2 = $('#section-home-2'),

	// $world_map_1_img = $('#world-map-1 > img'),

	$countries = $section_2.find('.fadein .countries:gt(0)'),

	$country = $section_2.find('.countries');

	$countries.hide();

	// $('#world-map-1 > img').height(1100 * $world_map_1_img.width() / 1600).width($world_map_1_img.width());

	setInterval(function(){
		$section_2.find('.countries:first-child').fadeOut(700)
		.next($country).fadeIn(700)
		.end().appendTo('.fadein');
	}, 5000);

	whitepapers();


	$('.owl-carousel').owlCarousel({
		type	   : 3,
		dots	   : false,
		slideBy	 : 3,
		margin   : 40,
		nav 	   : true,
		navText    : ['',''],
		responsive : {
			0 : {
				items:1
			},
			600 : {
				items:2
			},
			1000 : {
				items:3
			}
		}
	});


};
},{"../custom/whitepapers":12}],7:[function(require,module,exports){
"use strict";

function page_interaction () {

	var urls = location.hash.substr(1).split('/'),

	$active_collapse = $('#collapse-' + urls[0] ),

	$active_tab = urls.length === 1 ? $('[data-target="#tab-' + urls[0] + '"]') : 
				( urls.length === 2 ? $('[data-target="#tab-' + urls[0] + '-' + urls[1] + '"]') : []);

	if( !$active_tab.length ) 
	{
		$active_tab = urls.length === 1 ? $('[data-target=".tab-' + urls[0] + '"]') : 
					( urls.length === 2 ? $('[data-target=".tab-' + urls[0] + '-' + urls[1] + '"]') : []);
	}

	if( $active_collapse.length ) 
	{
		$active_collapse.collapse('show');

		$active_collapse.closest('.accordion-group').find('.accordion-collapse').each(function () {
			
			if ( this !== $active_collapse[0] ) $(this).collapse('hide');

		});
	}

	if( $active_tab.length ) 
		$active_tab.tab('show');

}

module.exports = function () {

	$('[data-toggle="collapse"],[data-toggle="tab"]').on('click',function(){
		location.hash = this.hash;
		// return false;
	});
	
	$(window).on('hashchange',page_interaction);
	page_interaction();


};
},{}],8:[function(require,module,exports){
'use strict';

var webinars = require('../custom/webinars');

module.exports = function  () {
	$('.owl-carousel').owlCarousel({
		type	   : 2,
	    dots	   : false,
	    slideBy	   : 2,
	    nav 	   : true,
	    navText    : ['',''],
	    responsive : {
	        0 : {
	            items:1
	        },
	        600 : {
	            items:2
	        },
	        1000 : {
	            items:2
	        }
	    }
	});

	webinars();
};
},{"../custom/webinars":11}],9:[function(require,module,exports){
'use strict';

var webinars = require('../custom/webinars');
var whitepapers = require('../custom/whitepapers');

module.exports = function  (argument) {
	var owlCarousel = function(className, defaultItem) {
		$(className).owlCarousel({
			type:6,
			loop:false,
			margin:10,
			nav:true,
			navText:['',''],
			responsive:{
				0:{
					items:2
				},
				600:{
					items:3
				},
				1000:{
					items:defaultItem
				}
			}
		});

	};

	owlCarousel('.default-carousel', 6);
	owlCarousel('.videos-carousel', 5);

	webinars();
	whitepapers();
};
},{"../custom/webinars":11,"../custom/whitepapers":12}],10:[function(require,module,exports){
'use strict';

var $sidebox = $('[data-toggle="sidebox"]');

if( $sidebox.length ) {
	$sidebox.on('click', function(){
		var $that = $(this);
		var $hbspt_form = $(this.hash ? this.hash : $that.data('target') ).find('.hbspt-form');
		if( $hbspt_form.data('hbsptform') !== undefined ) {
			$hbspt_form.data('hbsptform').create();
		}
		$(document).one('hbspt-form.onFormReady', '.hbspt-form',function() {
			$(this).closest('.sidebox-hbspt-form').fadeIn();
		});
	});

	$(document).on('hbspt-form.creating', '.hbspt-form',function() {
		$(this).closest('.sidebox-hbspt-form').css('display','none');
	});
}
},{}],11:[function(require,module,exports){
'use strict';

var countries = require('../data/country');

module.exports = function  () {
	var country_options = '<option>Select your country</option>', country;

	for (country in countries) {
		country_options += '<option value="'+country+'">'+countries[country].text+'</option>';
	}

	$('#container-webinar [data-toggle="sidebox"]').each(function(){
		var $element = $(this),

		data = $element.data();

		$element.removeAttr('data-id').removeAttr('data-media-source').removeAttr('data-webinars').removeAttr('data-type');

		function webinar (){
			var sidebox = $element.data('sidebox');
	
			if( sidebox ) {
				$element.attr({
					href   : data['mediaSource'],
					target : '_blank'
				});

				sidebox.close();

				setTimeout(function(){
					sidebox.destroy();

					if( data['type'] === 'video' ) {
						$element.magnificPopup({
							type : 'iframe'
						})[0].click();
					} else {
						window.open($element.attr('href'),'_blank');
					}	

				}, sidebox.options.speed);

				localStorage.setItem("webinars-" + data['id'], true);
			}
		}

		$element.on('click', function(){
			if( localStorage.getItem("webinars-" + data['id']) ) {
				webinar();
			} else {
				$(document).one('hbspt-form.onFormReady', '#sidebox-webinars .hbspt-form', function() {
					var $form = $(this), 

					$button = $form.find('input[type="submit"]'), $button_attrs = {};

					$form.find('input[name="webinars"]').val(data['webinars']);
					$form.find('select[name="country"]').html(country_options);
					$form.find('input[name="lead_response__c"]').val('Inbound');

					$.each($button[0].attributes, function(idx, attr) {
					    $button_attrs[attr.nodeName] = attr.nodeValue;
					});

					$button.replaceWith(function () {
						var contents = '';

						switch ( data['type'] ) {
							case 'video':
								contents = 'Watch Webinar';
								break;
							case 'audio':
								contents = 'Listen Webinar';
								break;
							case 'pdf':
								contents = 'View Webinar';
								break;
							default:
								contents = 'Submit';
								break;
						}

					    return $("<button />", $button_attrs).append(contents);
					});

				}).one('hbspt-form.onFormSubmit', '#sidebox-webinars .hbspt-form', webinar);
			}
		});
	});
	
	$(document).on('change','#sidebox-webinars .hbspt-form select[name="country"]', function(){
		var $that = $(this),

		$primary_lead_owner_c = $('#sidebox-webinars .hbspt-form input[name="primary_lead_owner__c"]'),

		country = $that.val();

		if( countries[country] !== undefined ){
			if ( country === 'US (United States)' ) {
				$primary_lead_owner_c.val('Michele Carchman');
			} else if ( countries[country]['continent'][0] === 'North America' || countries[country]['continent'][0] === 'Canada' )  {
				$primary_lead_owner_c.val('Michele Carchman');
			} else if ( countries[country]['continent'][0] === 'South America' || countries[country]['continent'][0] === 'USA' )  {
				$primary_lead_owner_c.val('Michele Carchman');
			} else if ( country === 'GB (United Kingdom)' ) {
				$primary_lead_owner_c.val('Ashley Blackmore');
			} else if ( ['FR (France)','ES (Spain)','PT (Portugal)'].indexOf(country) !== -1 ) {
				$primary_lead_owner_c.val('Ashley Blackmore');
			} else if ( countries[country]['continent'][0] === 'Europe' && 
					    ['Middle East','Africa'].indexOf(countries[country]['continent'][1]) === -1 &&
					    ['GB (United Kingdom)','FR (France)','ES (Spain)','PT (Portugal)'].indexOf(country) === -1 
			) {
				$primary_lead_owner_c.val('Ashley Blackmore');
			} else if ( countries[country]['continent'][0] === 'Australasia') {
				$primary_lead_owner_c.val('Michele Carchman');
			} else if ( countries[country]['continent'][0] == 'Asia' && countries[country]['continent'][1] !== 'Middle East' ) {
				$primary_lead_owner_c.val('Michele Carchman');
			} else if ( countries[country]['continent'][1] === 'Middle East' ) {
				$primary_lead_owner_c.val('Michele Carchman');
			} else if ( countries[country]['continent'][1] === 'Africa' ) {
				$primary_lead_owner_c.val('Pravin Eazhawa');
			} else {
				$primary_lead_owner_c.val('-');
			}
		}
	});
};
},{"../data/country":13}],12:[function(require,module,exports){
'use strict';

var countries = require('../data/country');

module.exports = function  () {
	var country_options = '<option>Select your country</option>', country;

	for (country in countries) {
		country_options += '<option value="'+country+'">'+countries[country].text+'</option>';
	}

	$('#container-whitepapers [data-toggle="sidebox"]').each(function(){
		var $element = $(this),

		data = $element.data();

		$element.removeAttr('data-id').removeAttr('data-media-source').removeAttr('data-webinars').removeAttr('data-type');

		function webinar (){
			var sidebox = $element.data('sidebox');
	
			if( sidebox ) {
				$element.attr({
					href   : data['mediaSource'],
					target : '_blank'
				});

				sidebox.close();

				setTimeout(function(){
					sidebox.destroy();

					if( data['type'] === 'video' ) {
						$element.magnificPopup({
							type : 'iframe'
						})[0].click();
					} else {
						window.open($element.attr('href'),'_blank');
					}	

				}, sidebox.options.speed);

				localStorage.setItem("whitepapers-" + data['id'], true);
			}
		}

		$element.on('click', function(){
			if( localStorage.getItem("whitepapers-" + data['id']) ) {
				webinar();
			} else {
				$(document).one('hbspt-form.onFormReady', '#sidebox-whitepapers .hbspt-form', function() {
					var $form = $(this), 

					$button = $form.find('input[type="submit"]'), $button_attrs = {};


					$.each($button[0].attributes, function(idx, attr) {
					    $button_attrs[attr.nodeName] = attr.nodeValue;
					});

					$button.replaceWith(function () {
						var contents = '';

						switch ( data['type'] ) {
							case 'pdf':
								contents = 'View Whitepaper';
								break;
							default:
								contents = 'Submit';
								break;
						}

					    return $("<button />", $button_attrs).append(contents);
					});

				}).one('hbspt-form.onFormSubmit', '#sidebox-whitepapers .hbspt-form', webinar);
			}
		});
	});
	
	$(document).on('change','#sidebox-whitepapers .hbspt-form select[name="country"]', function(){
		var $that = $(this),

		$primary_lead_owner_c = $('#sidebox-whitepapers .hbspt-form input[name="primary_lead_owner__c"]'),

		country = $that.val();

		if( countries[country] !== undefined ){
			if ( country === 'US (United States)' ) {
				$primary_lead_owner_c.val('Michele Carchman');
			} else if ( countries[country]['continent'][0] === 'North America' || countries[country]['continent'][0] === 'Canada' )  {
				$primary_lead_owner_c.val('Michele Carchman');
			} else if ( countries[country]['continent'][0] === 'South America' || countries[country]['continent'][0] === 'USA' )  {
				$primary_lead_owner_c.val('Michele Carchman');
			} else if ( country === 'GB (United Kingdom)' ) {
				$primary_lead_owner_c.val('Ashley Blackmore');
			} else if ( ['FR (France)','ES (Spain)','PT (Portugal)'].indexOf(country) !== -1 ) {
				$primary_lead_owner_c.val('Ashley Blackmore');
			} else if ( countries[country]['continent'][0] === 'Europe' && 
					    ['Middle East','Africa'].indexOf(countries[country]['continent'][1]) === -1 &&
					    ['GB (United Kingdom)','FR (France)','ES (Spain)','PT (Portugal)'].indexOf(country) === -1 
			) {
				$primary_lead_owner_c.val('Ashley Blackmore');
			} else if ( countries[country]['continent'][0] === 'Australasia') {
				$primary_lead_owner_c.val('Michele Carchman');
			} else if ( countries[country]['continent'][0] == 'Asia' && countries[country]['continent'][1] !== 'Middle East' ) {
				$primary_lead_owner_c.val('Michele Carchman');
			} else if ( countries[country]['continent'][1] === 'Middle East' ) {
				$primary_lead_owner_c.val('Michele Carchman');
			} else if ( countries[country]['continent'][1] === 'Africa' ) {
				$primary_lead_owner_c.val('Pravin Eazhawa');
			} else {
				$primary_lead_owner_c.val('-');
			}
		}
	});
};
},{"../data/country":13}],13:[function(require,module,exports){
'use strict';

module.exports = {
	'US (United States)' : {
		text: 'United States',
		continent : ['USA']
	},
	'AF (Afghanistan)' : {
		text: 'Afghanistan',
		continent : ['Asia']
	},
	'AL (Albania)' : {
		text: 'Albania',
		continent : ['Europe']
	},
	'DZ (Algeria)' : {
		text: 'Algeria',
		continent : ['Europe','Africa']
	},
	'AS (American Samoa)' : {
		text: 'American Samoa',
		continent : ['USA']
	},
	'AD (Andorra)' : {
		text: 'Andorra',
		continent : ['Europe']
	},
	'AO (Angola)' : {
		text: 'Angola',
		continent : ['Europe','Africa']
	},
	'AI (Anguilla)' : {
		text: 'Anguilla',
		continent : ['North America']
	},
	'AG (Antigua and Barbuda)' : {
		text: 'Antigua and Barbuda',
		continent : ['North America']
	},
	'AR (Argentina)' : {
		text: 'Argentina',
		continent : ['South America']
	},
	'AM (Armenia)' : {
		text: 'Armenia',
		continent : ['Europe']
	},
	'AW (Aruba)' : {
		text: 'Aruba',
		continent : ['North America']
	},
	'AU (Australia)' : {
		text: 'Australia',
		continent : ['Australasia']
	},
	'AT (Austria)' : {
		text: 'Austria',
		continent : ['Europe']
	},
	'AZ (Azerbaijan)' : {
		text: 'Azerbaijan',
		continent : ['Europe']
	},
	'BS (Bahamas)' : {
		text: 'Bahamas',
		continent : ['North America']
	},
	'BH (Bahrain)' : {
		text: 'Bahrain',
		continent : ['Asia','Middle East']
	},
	'BD (Bangladesh)' : {
		text: 'Bangladesh',
		continent : ['Asia']
	},
	'BB (Barbados)' : {
		text: 'Barbados',
		continent : ['North America']
	},
	'BY (Belarus)' : {
		text: 'Belarus',
		continent : ['Europe']
	},
	'BE (Belgium)' : {
		text: 'Belgium',
		continent : ['Europe']
	},
	'BZ (Belize)' : {
		text: 'Belize',
		continent : ['North America']
	},
	'BJ (Benin)' : {
		text: 'Benin',
		continent : ['Europe','Africa']
	},
	'BM (Bermuda)' : {
		text: 'Bermuda',
		continent : ['North America']
	},
	'BT (Bhutan)' : {
		text: 'Bhutan',
		continent : ['Asia']
	},
	'BO (Bolivia)' : {
		text: 'Bolivia',
		continent : ['South America']
	},
	'BA (Bosnia and Herzegowina)' : {
		text: 'Bosnia and Herzegowina',
		continent : ['Europe']
	},
	'BW (Botswana)' : {
		text: 'Botswana',
		continent : ['Europe','Africa']
	},
	'BV (Bouvet Island)' : {
		text: 'Bouvet Island',
		continent : ['Europe']
	},
	'BR (Brazil)' : {
		text: 'Brazil',
		continent : ['South America']
	},
	'IO (British Indian Ocean Territory)' : {
		text: 'British Indian Ocean Territory',
		continent : ['Europe']
	},
	'BN (Brunei Darussalam)' : {
		text: 'Brunei Darussalam',
		continent : ['Asia']
	},
	'BG (Bulgaria)' : {
		text: 'Bulgaria',
		continent : ['Europe']
	},
	'BF (Burkina Faso)' : {
		text: 'Burkina Faso',
		continent : ['Europe','Asia']
	},
	'BI (Burundi)' : {
		text: 'Burundi',
		continent : ['Europe','Africa']
	},
	'KH (Cambodia)' : {
		text: 'Cambodia',
		continent : ['Asia']
	},
	'CM (Cameroon)' : {
		text: 'Cameroon',
		continent : ['Europe','Africa']
	},
	'CA (Canada)' : {
		text: 'Canada',
		continent : ['Canada']
	},
	'CV (Cape Verde)' : {
		text: 'Cape Verde',
		continent : ['Europe','Africa']
	},
	'KY (Cayman Islands)' : {
		text: 'Cayman Islands',
		continent : ['North America']
	},
	'CF (Central African Republic)' : {
		text: 'Central African Republic',
		continent : ['Europe','Africa']
	},
	'TD (Chad)' : {
		text: 'Chad',
		continent : ['Europe','Africa']
	},
	'CL (Chile)' : {
		text: 'Chile',
		continent : ['South America']
	},
	'CN (China)' : {
		text: 'China',
		continent : ['Asia']
	},
	'CX (Christmas Island)' : {
		text: 'Christmas Island',
		continent : ['Australasia']
	},
	'CC (Cocos)' : {
		text: 'Cocos',
		continent : ['Australasia']
	},
	'CO (Colombia)' : {
		text: 'Colombia',
		continent : ['South America']
	},
	'KM (Comoros)' : {
		text: 'Comoros',
		continent : ['Europe','Africa']
	},
	'CG (Congo)' : {
		text: 'Congo',
		continent : ['Europe','Africa']
	},
	'CD (The Democratic Republic of the Congo)' : {
		text: 'The Democratic Republic of the Congo',
		continent : ['sss']
	},
	'CK (Cook Islands)' : {
		text: 'Cook Islands',
		continent : ['Australasia','Oceania']
	},
	'CR (Costa Rica)' : {
		text: 'Costa Rica',
		continent : ['North America']
	},
	'CI (Cote d\'Ivoire)' : {
		text: 'Cote d\'Ivoire',
		continent : ['Europe','Africa']
	},
	'HR (Croatia [Hrvatska])' : {
		text: 'Croatia [Hrvatska]',
		continent : ['Europe']
	},
	'CU (Cuba)' : {
		text: 'Cuba',
		continent : ['North America']
	},
	'CY (Cyprus)' : {
		text: 'Cyprus',
		continent : ['Europe','Middle East']
	},
	'CZ (Czech Republic)' : {
		text: 'Czech Republic',
		continent : ['Europe']
	},
	'DK (Denmark)' : {
		text: 'Denmark',
		continent : ['Europe']
	},
	'DJ (Djibouti)' : {
		text: 'Djibouti',
		continent : ['Europe','Africa']
	},
	'DM (Dominica)' : {
		text: 'Dominica',
		continent : ['North America']
	},
	'DO (Dominican Republic)' : {
		text: 'Dominican Republic',
		continent : ['North America']
	},
	'TP (East Timor)' : {
		text: 'East Timor',
		continent : ['Asia']
	},
	'EC (Ecuador)' : {
		text: 'Ecuador',
		continent : ['South America']
	},
	'EG (Egypt)' : {
		text: 'Egypt',
		continent : ['sss']
	},
	'SV (El Salvador)' : {
		text: 'El Salvador',
		continent : ['North America']
	},
	'GQ (Equatorial Guinea)' : {
		text: 'Equatorial Guinea',
		continent : ['Europe','Africa']
	},
	'ER (Eritrea)' : {
		text: 'Eritrea',
		continent : ['Europe','Africa']
	},
	'EE (Estonia)' : {
		text: 'Estonia',
		continent : ['Europe']
	},
	'ET (Ethiopia)' : {
		text: 'Ethiopia',
		continent : ['Europe','Africa']
	},
	'FK (Falkland Islands [Malvinas])' : {
		text: 'Falkland Islands [Malvinas]',
		continent : ['South America']
	},
	'FO (Faroe Islands)' : {
		text: 'Faroe Islands',
		continent : ['Europe']
	},
	'FJ (Fiji)' : {
		text: 'Fiji',
		continent : ['Australasia','Oceania']
	},
	'FI (Finland)' : {
		text: 'Finland',
		continent : ['Europe']
	},
	'FR (France)' : {
		text: 'France',
		continent : ['Europe']
	},
	'FX (France, Metropolitan)' : {
		text: 'France, Metropolitan',
		continent : ['Europe']
	},
	'GF (French Guiana)' : {
		text: 'French Guiana',
		continent : ['South America']
	},
	'PF (French Polynesia)' : {
		text: 'French Polynesia',
		continent : ['Europe']
	},
	'TF (French Southern Territories)' : {
		text: 'French Southern Territories',
		continent : ['Europe']
	},
	'GA (Gabon)' : {
		text: 'Gabon',
		continent : ['Europe','Africa']
	},
	'GM (Gambia)' : {
		text: 'Gambia',
		continent : ['Europe','Africa']
	},
	'GE (Georgia)' : {
		text: 'Georgia',
		continent : ['Europe']
	},
	'DE (Germany)' : {
		text: 'Germany',
		continent : ['Europe']
	},
	'GH (Ghana)' : {
		text: 'Ghana',
		continent : ['Europe','Africa']
	},
	'GI (Gibraltar)' : {
		text: 'Gibraltar',
		continent : ['Europe']
	},
	'GR (Greece)' : {
		text: 'Greece',
		continent : ['Europe']
	},
	'GL (Greenland)' : {
		text: 'Greenland',
		continent : ['North America']
	},
	'GD (Grenada)' : {
		text: 'Grenada',
		continent : ['North America']
	},
	'GP (Guadeloupe)' : {
		text: 'Guadeloupe',
		continent : ['North America']
	},
	'GU (Guam)' : {
		text: 'Guam',
		continent : ['USA']
	},
	'GT (Guatemala)' : {
		text: 'Guatemala',
		continent : ['North America']
	},
	'GN (Guinea)' : {
		text: 'Guinea',
		continent : ['Europe','Africa']
	},
	'GW (Guinea-Bissau)' : {
		text: 'Guinea-Bissau',
		continent : ['South America']
	},
	'GY (Guyana)' : {
		text: 'Guyana',
		continent : ['South America']
	},
	'HT (Haiti)' : {
		text: 'Haiti',
		continent : ['North America']
	},
	'HM (Heard and Mc Donald Islands)' : {
		text: 'Heard and Mc Donald Islands',
		continent : ['Australasia']
	},
	'VA (Holy See)' : {
		text: 'Holy See',
		continent : ['Europe']
	},
	'HN (Honduras)' : {
		text: 'Honduras',
		continent : ['North America']
	},
	'HK (Hong Kong)' : {
		text: 'Hong Kong',
		continent : ['Asia']
	},
	'HU (Hungary)' : {
		text: 'Hungary',
		continent : ['Europe']
	},
	'IS (Iceland)' : {
		text: 'Iceland',
		continent : ['Europe']
	},
	'IN (India)' : {
		text: 'India',
		continent : ['Asia']
	},
	'ID (Indonesia)' : {
		text: 'Indonesia',
		continent : ['Asia']
	},
	'IR (Iran [Islamic Republic of Iran])' : {
		text: 'Iran [Islamic Republic of Iran]',
		continent : ['Asia','Middle East']
	},
	'IQ (Iraq)' : {
		text: 'Iraq',
		continent : ['Asia','Middle East']
	},
	'IE (Ireland)' : {
		text: 'Ireland',
		continent : ['Europe']
	},
	'IL (Israel)' : {
		text: 'Israel',
		continent : ['Asia','Middle East']
	},
	'IT (Italy)' : {
		text: 'Italy',
		continent : ['Europe']
	},
	'JM (Jamaica)' : {
		text: 'Jamaica',
		continent : ['North America']
	},
	'JP (Japan)' : {
		text: 'Japan',
		continent : ['Asia']
	},
	'JO (Jordan)' : {
		text: 'Jordan',
		continent : ['Asia','Middle East']
	},
	'KZ (Kazakhstan)' : {
		text: 'Kazakhstan',
		continent : ['Europe']
	},
	'KE (Kenya)' : {
		text: 'Kenya',
		continent : ['Europe','Africa']
	},
	'KI (Kiribati)' : {
		text: 'Kiribati',
		continent : ['Australasia']
	},
	'KP (Democratic People\'s Republic of Korea)' : {
		text: 'Democratic People\'s Republic of Korea',
		continent : ['Asia']
	},
	'KR (Republic of Korea)' : {
		text: 'Republic of Korea',
		continent : ['Asia']
	},
	'KW (Kuwait)' : {
		text: 'Kuwait',
		continent : ['Asia','Middle East']
	},
	'KG (Kyrgyzstan)' : {
		text: 'Kyrgyzstan',
		continent : ['Asia']
	},
	'LA (Lao People\'s Democratic Republic)' : {
		text: 'Lao People\'s Democratic Republic',
		continent : ['Asia']
	},
	'LV (Latvia)' : {
		text: 'Latvia',
		continent : ['Europe']
	},
	'LB (Lebanon)' : {
		text: 'Lebanon',
		continent : ['Asia','Middle East']
	},
	'LS (Lesotho)' : {
		text: 'Lesotho',
		continent : ['Europe','Africa']
	},
	'LR (Liberia)' : {
		text: 'Liberia',
		continent : ['Europe','Africa']
	},
	'LY (Libyan Arab Jamahiriya)' : {
		text: 'Libyan Arab Jamahiriya',
		continent : ['Europe','Africa']
	},
	'LI (Liechtenstein)' : {
		text: 'Liechtenstein',
		continent : ['Europe']
	},
	'LT (Lithuania)' : {
		text: 'Lithuania',
		continent : ['Europe']
	},
	'LU (Luxembourg)' : {
		text: 'Luxembourg',
		continent : ['Europe']
	},
	'MO (Macau)' : {
		text: 'Macau',
		continent : ['Asia']
	},
	'MK (The Former Yugoslav Republic of Macedonia)' : {
		text: 'The Former Yugoslav Republic of Macedonia',
		continent : ['Europe']
	},
	'MG (Madagascar)' : {
		text: 'Madagascar',
		continent : ['Europe','Africa']
	},
	'MW (Malawi)' : {
		text: 'Malawi',
		continent : ['Europe','Africa']
	},
	'MY (Malaysia)' : {
		text: 'Malaysia',
		continent : ['Europe']
	},
	'MV (Maldives)' : {
		text: 'Maldives',
		continent : ['Europe']
	},
	'ML (Mali)' : {
		text: 'Mali',
		continent : ['Europe','Africa']
	},
	'MT (Malta)' : {
		text: 'Malta',
		continent : ['Europe']
	},
	'MH (Marshall Islands)' : {
		text: 'Marshall Islands',
		continent : ['Australasia']
	},
	'MQ (Martinique)' : {
		text: 'Martinique',
		continent : ['North America']
	},
	'MR (Mauritania)' : {
		text: 'Mauritania',
		continent : ['Europe','Africa']
	},
	'MU (Mauritius)' : {
		text: 'Mauritius',
		continent : ['Europe','Africa']
	},
	'YT (Mayotte)' : {
		text: 'Mayotte',
		continent : ['Europe']
	},
	'MX (Mexico)' : {
		text: 'Mexico',
		continent : ['North America']
	},
	'FM (Federated States of Micronesia)' : {
		text: 'Federated States of Micronesia',
		continent : ['Australasia']
	},
	'MD (Republic of Moldova)' : {
		text: 'Republic of Moldova',
		continent : ['Europe']
	},
	'MC (Monaco)' : {
		text: 'Monaco',
		continent : ['Europe']
	},
	'MN (Mongolia)' : {
		text: 'Mongolia',
		continent : ['Asia']
	},
	'MS (Montserrat)' : {
		text: 'Montserrat',
		continent : ['North America']
	},
	'MA (Morocco)' : {
		text: 'Morocco',
		ccontinent : ['Europe','Africa']
	},
	'MZ (Mozambique)' : {
		text: 'Mozambique',
		continent : ['Europe','Africa']
	},
	'MM (Myanmar)' : {
		text: 'Myanmar',
		continent : ['Asia']
	},
	'NA (Namibia)' : {
		text: 'Namibia',
		continent : ['Europe','Africa']
	},
	'NR (Nauru)' : {
		text: 'Nauru',
		continent : ['Australasia']
	},
	'NP (Nepal)' : {
		text: 'Nepal',
		continent : ['Asia']
	},
	'NL (Netherlands)' : {
		text: 'Netherlands',
		continent : ['Europe']
	},
	'AN (Netherlands Antilles)' : {
		text: 'Netherlands Antilles',
		continent : ['Europe']
	},
	'NC (New Caledonia)' : {
		text: 'New Caledonia',
		continent : ['Australasia']
	},
	'NZ (New Zealand)' : {
		text: 'New Zealand',
		continent : ['Australasia']
	},
	'NI (Nicaragua)' : {
		text: 'Nicaragua',
		continent : ['North America']
	},
	'NE (Niger)' : {
		text: 'Niger',
		continent : ['Europe','Africa']
	},
	'NG (Nigeria)' : {
		text: 'Nigeria',
		continent : ['Europe','Africa']
	},
	'NU (Niue)' : {
		text: 'Niue',
		continent : ['Australasia','Oceania']
	},
	'NF (Norfolk Island)' : {
		text: 'Norfolk Island',
		continent : ['Australasia']
	},
	'MP (Northern Mariana Islands)' : {
		text: 'Northern Mariana Islands',
		continent : ['USA']
	},
	'NO (Norway)' : {
		text: 'Norway',
		continent : ['Europe']
	},
	'OM (Oman)' : {
		text: 'Oman',
		continent : ['Asia','Middle East']
	},
	'PK (Pakistan)' : {
		text: 'Pakistan',
		continent : ['Asia']
	},
	'PW (Palau)' : {
		text: 'Palau',
		continent : ['Australasia']
	},
	'PA (Panama)' : {
		text: 'Panama',
		continent : ['North America']
	},
	'PG (Papua New Guinea)' : {
		text: 'Papua New Guinea',
		continent : ['Asia']
	},
	'PY (Paraguay)' : {
		text: 'Paraguay',
		continent : ['South America']
	},
	'PE (Peru)' : {
		text: 'Peru',
		continent : ['South America']
	},
	'PH (Philippines)' : {
		text: 'Philippines',
		continent : ['Asia']
	},
	'PN (Pitcairn)' : {
		text: 'Pitcairn',
		continent : ['Australasia']
	},
	'PL (Poland)' : {
		text: 'Poland',
		continent : ['Europe']
	},
	'PT (Portugal)' : {
		text: 'Portugal',
		continent : ['Europe']
	},
	'PR (Puerto Rico)' : {
		text: 'Puerto Rico',
		continent : ['North America']
	},
	'QA (Qatar)' : {
		text: 'Qatar',
		continent : ['Asia','Middle East']
	},
	'RE (Reunion)' : {
		text: 'Reunion',
		continent : ['Europe']
	},
	'RO (Romania)' : {
		text: 'Romania',
		continent : ['Europe']
	},
	'RU (Russian Federation)' : {
		text: 'Russian Federation',
		continent : ['Europe']
	},
	'RW (Rwanda)' : {
		text: 'Rwanda',
		continent : ['Europe','Africa']
	},
	'KN (Saint Kitts and Nevis)' : {
		text: 'Saint Kitts and Nevis',
		continent : ['North America']
	},
	'LC (Saint Lucia)' : {
		text: 'Saint Lucia',
		continent : ['North America']
	},
	'VC (Saint Vincent and the Grenadines)' : {
		text: 'Saint Vincent and the Grenadines',
		continent : ['North America']
	},
	'WS (Samoa)' : {
		text: 'Samoa',
		continent : ['Austria','Oceania']
	},
	'SM (San Marino)' : {
		text: 'San Marino',
		continent : ['Europe']
	},
	'ST (Sao Tome and Principe)' : {
		text: 'Sao Tome and Principe',
		continent : ['Europe','Africa']
	},
	'SA (Saudi Arabia)' : {
		text: 'Saudi Arabia',
		continent : ['Asia','Middle East']
	},
	'SN (Senegal)' : {
		text: 'Senegal',
		continent : ['Europe','Africa']
	},
	'SC (Seychelles)' : {
		text: 'Seychelles',
		continent : ['Europe','Africa']
	},
	'SL (Sierra Leone)' : {
		text: 'Sierra Leone',
		continent : ['Europe','Africa']
	},
	'SG (Singapore)' : {
		text: 'Singapore',
		continent : ['Asia']
	},
	'SK (Slovakia [Slovak Republic])' : {
		text: 'Slovakia [Slovak Republic]',
		continent : ['Europe']
	},
	'SI (Slovenia)' : {
		text: 'Slovenia',
		continent : ['Europe']
	},
	'SB (Solomon Islands)' : {
		text: 'Solomon Islands',
		continent : ['Australasia','Africa']
	},
	'SO (Somalia)' : {
		text: 'Somalia',
		continent : ['Europe','Africa']
	},
	'ZA (South Africa)' : {
		text: 'South Africa',
		continent : ['Europe','Africa']
	},
	'GS (South Georgia and the South Sandwich Islands)' : {
		text: 'South Georgia and the South Sandwich Islands',
		continent : ['South America']
	},
	'ES (Spain)' : {
		text: 'Spain',
		continent : ['Europe']
	},
	'LK (Sri Lanka)' : {
		text: 'Sri Lanka',
		continent : ['Asia']
	},
	'SH (St. Helena)' : {
		text: 'St. Helena',
		continent : ['Europe']
	},
	'PM (St. Pierre and Miquelon)' : {
		text: 'St. Pierre and Miquelon',
		continent : ['Europe']
	},
	'SD (Sudan)' : {
		text: 'Sudan',
		continent : ['Europe','Africa']
	},
	'SR (Suriname)' : {
		text: 'Suriname',
		continent : ['South America']
	},
	'SZ (Swaziland)' : {
		text: 'Swaziland',
		continent : ['Europe','Africa']
	},
	'SE (Sweden)' : {
		text: 'Sweden',
		continent : ['Europe']
	},
	'CH (Switzerland)' : {
		text: 'Switzerland',
		continent : ['Europe']
	},
	'SY (Syrian Arab Republic)' : {
		text: 'Syrian Arab Republic',
		continent : ['Asia','Middle East']
	},
	'TW (Taiwan, Province of China)' : {
		text: 'Taiwan, Province of China',
		continent : ['Asia']
	},
	'TJ (Tajikistan)' : {
		text: 'Tajikistan',
		continent : ['Asia']
	},
	'TZ (United Republic of Tanzania)' : {
		text: 'United Republic of Tanzania',
		continent : ['Europe','Africa']
	},
	'TH (Thailand)' : {
		text: 'Thailand',
		continent : ['Asia']
	},
	'TG (Togo)' : {
		text: 'Togo',
		continent : ['Europe','Africa']
	},
	'TK (Tokelau)' : {
		text: 'Tokelau',
		continent : ['Australasia','Oceania']
	},
	'TO (Tonga)' : {
		text: 'Tonga',
		continent : ['Australasia','Oceania']
	},
	'TT (Trinidad and Tobago)' : {
		text: 'Trinidad and Tobago',
		continent : ['North America']
	},
	'TN (Tunisia)' : {
		text: 'Tunisia',
		continent : ['Europe','Africa']
	},
	'TR (Turkey)' : {
		text: 'Turkey',
		continent : ['Europe','Middle East']
	},
	'TM (Turkmenistan)' : {
		text: 'Turkmenistan',
		continent : ['Asia']
	},
	'TC (Turks and Caicos Islands)' : {
		text: 'Turks and Caicos Islands',
		continent : ['North America']
	},
	'TV (Tuvalu)' : {
		text: 'Tuvalu',
		continent : ['Australasia','Oceania']
	},
	'UG (Uganda)' : {
		text: 'Uganda',
		continent : ['Europe','Africa']
	},
	'UA (Ukraine)' : {
		text: 'Ukraine',
		continent : ['Europe']
	},
	'AE (United Arab Emirates)' : {
		text: 'United Arab Emirates',
		continent : ['Asia','Middle East']
	},
	'GB (United Kingdom)' : {
		text: 'United Kingdom',
		continent : ['Europe']
	},
	'UM (United States Minor Outlying Islands)' : {
		text: 'United States Minor Outlying Islands',
		continent : ['USA']
	},
	'UY (Uruguay)' : {
		text: 'Uruguay',
		continent : ['South America']
	},
	'UZ (Uzbekistan)' : {
		text: 'Uzbekistan',
		continent : ['Asia']
	},
	'VU (Vanuatu)' : {
		text: 'Vanuatu',
		continent : ['Australasia','Oceania']
	},
	'VE (Venezuela)' : {
		text: 'Venezuela',
		continent : ['South America']
	},
	'VN (Viet Nam)' : {
		text: 'Viet Nam',
		continent : ['Asia']
	},
	'VG (Virgin Islands [British])' : {
		text: 'Virgin Islands [British]',
		continent : ['North America']
	},
	'VI (Virgin Islands [U.S.])' : {
		text: 'Virgin Islands [U.S.]',
		continent : ['USA']
	},
	'WF (Wallis and Futuna Islands)' : {
		text: 'Wallis and Futuna Islands',
		continent : ['Australasia','Oceania']
	},
	'EH (Western Sahara)' : {
		text: 'Western Sahara',
		continent : ['Europe']
	},
	'YE (Yemen)' : {
		text: 'Yemen',
		continent : ['Asia','Middle East']
	},
	'YU (Yugoslavia)' : {
		text: 'Yugoslavia',
		continent : ['Europe']
	},
	'ZM (Zambia)' : {
		text: 'Zambia',
		continent : ['Europe','Africa']
	},
	'ZW (Zimbabwe)' : {
		text: 'Zimbabwe',
		continent : ['Europe','Africa']
	},
};
},{}],14:[function(require,module,exports){
'use strict';

var mediaquery  = require('./lib/media-query');
var CONTROLLERS = {'clients': require('./controllers/clients.js'),'corporate-profile': require('./controllers/corporate-profile.js'),'greenwatch': require('./controllers/greenwatch.js'),'home': require('./controllers/home.js'),'industry-expertise': require('./controllers/industry-expertise.js'),'news-and-events': require('./controllers/news-and-events.js'),'resources': require('./controllers/resources.js')};
var asyncloadsocialmedia = require('./lib/async-load-social-media');

// load fn jquery
require('./jquery/hubspot-form.js');require('./jquery/serialize-object.js');require('./jquery/sidebox.js');require('./jquery/svg-tip.js');require('./jquery/timeline.js');

// init media-query
mediaquery();

// async all social media script
asyncloadsocialmedia();

// document ready
$(function() {
	// add class when document is ready
	$('body').addClass('document-ready');

 	// UI
 	require('./ui/hubspot-form.js');require('./ui/magnific-popup.js');require('./ui/navbar.js');require('./ui/parallax.js');require('./ui/scroll.js');require('./ui/sidebar.js');require('./ui/sidebox.js');require('./ui/svg-tip.js');require('./ui/timeline.js');

 	// Get all data-section and execute its function
    $('[data-controller]').each(function(){
    	
    	var that 	   = $(this),

    		data 	   = that.data(),

    		controller = data.controller;

    	delete data.controller;

    	if( typeof CONTROLLERS[ controller ] === 'function' ) CONTROLLERS[ controller ](data);
    	
    });  

 	require('./custom/index.js');
});

// add class when window is loaded
$(window).on('load', function(){
	$('body').addClass('window-loaded');
	// fix some layout
	$(this).trigger('resize');
});

// $(window).load(function(){
//     setTimeout(function(){
//         alert('hahaha');
//         $(window).trigger('resize');
//     }, 5000);
// });
},{"./controllers/clients.js":3,"./controllers/corporate-profile.js":4,"./controllers/greenwatch.js":5,"./controllers/home.js":6,"./controllers/industry-expertise.js":7,"./controllers/news-and-events.js":8,"./controllers/resources.js":9,"./custom/index.js":10,"./jquery/hubspot-form.js":15,"./jquery/serialize-object.js":16,"./jquery/sidebox.js":17,"./jquery/svg-tip.js":18,"./jquery/timeline.js":19,"./lib/async-load-social-media":20,"./lib/media-query":24,"./ui/hubspot-form.js":27,"./ui/magnific-popup.js":28,"./ui/navbar.js":29,"./ui/parallax.js":30,"./ui/scroll.js":31,"./ui/sidebar.js":32,"./ui/sidebox.js":33,"./ui/svg-tip.js":34,"./ui/timeline.js":35}],15:[function(require,module,exports){
'use strict';
 
var id_generator = require('../lib/id-generator');
var register_fn = require('../lib/register-fn');

function HbsptForm (element, options) {

    var that = this;

    that.element = element;
    that.$element = $(element);

    that.options  = $.extend({},{
        css              : '',
        cssRequired      : '',
        onBeforeFormInit : function() {
            setTimeout(function(){
                that.$element.trigger('hbspt-form.onBeforeFormInit');
            }, 1);
        },
        onFormReady      : function () {
            setTimeout(function(){
                that.$element.trigger('hbspt-form.onFormReady');
            }, 1);
        },
        onFormSubmit     : function () {
            setTimeout(function(){
                that.$element.trigger('hbspt-form.onFormSubmit');
            }, 1);
        },
        target           : '#hbspt-form' + id_generator(),
    }, options);

    that.create();

    // create_form(); 

    // $(document).on('hbspt-form.recreate', '.hbspt-form', function(e){
    //     if( e.target === $element[0] ) {
    //         $element.trigger('hbspt-form.creating');
    //         $(options.target).remove();
    //         $element.html($('<div id="'+id+'"></div>'));
    //         hbspt.forms.create(options);        
    //     }
    // })

    // $element.trigger('hbspt-form.recreate');
}

HbsptForm.prototype.create = function() {
    var that = this;
    that.$element.trigger('hbspt-form.creating');
    $(that.options.target).remove();
    that.$element.html($('<div id="'+that.options.target.substr(1)+'"></div>'));
    hbspt.forms.create(that.options);
};

register_fn('hbsptform', HbsptForm);
},{"../lib/id-generator":22,"../lib/register-fn":25}],16:[function(require,module,exports){
'use strict';

$.fn.serializeObject = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
        if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};
},{}],17:[function(require,module,exports){
'use strict';

var vendor_prefixes = require('../lib/vendor-prefixes');
var register_fn = require('../lib/register-fn');

var init = false;

function SideBox (element, options) {
	var that = this;

	that.element = element;
	that.$element = $(element);

	that.options = $.extend({},{
		cursor   : '',
		offset   : 0,
		position : ['left','right'].indexOf( options.position ) === -1 ? 'left' : options.position,
		speed    : 400,
		width    : 500
	}, options),

	that.$content = that.$element[0].hash ? $(that.$element[0].hash) : $(that.$element.data('target'));
	that.$sidebox = $('.sidebox');
	that.$sideboxwrapper = $('.sidebox-wrapper');
	that.$sideboxbackdrop = $('.sidebox-backdrop');

	if(!init) that.init();

	that.$sideboxcontent = that.$sidebox.find('> .sidebox-content');

	that.$element.on('click', $.proxy(that.transition,that));
}

SideBox.prototype.init = function(){
	var that = this,

	$body = $('body'),

	o_width = that.get_width();

	$body.find('> [data-sidebox-wrap="true"]').wrapAll('<div class="sidebox-wrapper"></div>');
	
	that.$sideboxwrapper = $body.find('> .sidebox-wrapper').css('transition', vendor_prefixes('transform') + ' ' + that.options.speed + 'ms');

	that.$sidebox = $('<div class="sidebox"><div class="sidebox-content"></div><div class="sidebox-close"></div></div>').css({
		'bottom'     : 0,
		'position'   : 'fixed',
		'top'        : 0, 
		'transition' : vendor_prefixes('transform') + ' ' + that.options.speed + 'ms',
		'transform'  : 'translate('+(that.options.position === 'left' ? '-' : '' )+(o_width + that.options.offset)+'px, 0)',
		'width'      : o_width,
		'z-index'    : 9999
	});

	that.$sideboxbackdrop = $('<div class="sidebox-backdrop"></div>').css({
		'background-color' : 'rgba(0,0,0,0)',
		'cursor'		   : 'url('+that.options.cursor+'), default',
		'transition' 	   : 'background-color ' + that.options.speed + 'ms',
		'z-index'    	   : 9998
	});

	if( that.options.position === 'left' ) {
		that.$sidebox.css('left', 0);
	} else {
		that.$sidebox.css('right', 0);
	}

	$body.append(that.$sidebox);
	$body.append(that.$sideboxbackdrop);

	that.$sidebox.find('> .sidebox-close').on('click',function () {
		if( $body.hasClass('sidebox-open') ) {
			that.close();
		}
	});

	that.$sideboxbackdrop.on('click', function (e) {
		if( $body.hasClass('sidebox-open') && $(e.target).data('toggle') !== 'sidebox' ) {
			that.close();
		}
	});

	$(window).on('resize', function(){
		var o_width = that.get_width();

		that.$sidebox.css('width', o_width);

		if( $body.hasClass('sidebox-open') ) {
			that.open();
		} else {
			that.close();
		}
	});

	init = true;
};

SideBox.prototype.get_width = function(){
	var $window = $(window);
	return (this.options.width + this.options.offset) < $window.width() ? this.options.width : $window.width() - this.options.offset;
};

SideBox.prototype.close = function(){
	var that = this,

	o_width = that.get_width();

	that.$element.trigger('sidebox.closing').trigger('sidebox.transitioning');

	$('body').css('overflow','').removeClass('sidebox-open');

	that.$sidebox.css({
		'transform' : 'translate('+(that.options.position === 'left' ? '-' : '' )+(o_width + that.options.offset)+'px, 0)'
	});

	that.$sideboxwrapper.css({
		'transform' : 'translate(0, 0)'
	});

	that.$sideboxbackdrop.css({
		'background-color' : 'rgba(0,0,0,0)',
		'bottom'     	   : '',
		'left'       	   : '',
		'position'   	   : '',
		'right'      	   : '',
		'top'        	   : ''
	});
};

SideBox.prototype.open = function(){
	var that = this,

	o_width = that.get_width();

	that.$element.trigger('sidebox.opening').trigger('sidebox.transitioning');

	$('body').css('overflow','hidden').addClass('sidebox-open');

	that.$sidebox.css({
		'transform' : 'translate(0, 0)'
	});

	that.$sideboxwrapper.css({
		'transform' : 'translate('+(that.options.position === 'left' ? '' : '-' )+o_width+'px, 0)'
	});

	that.$sideboxbackdrop.css({
		'background-color' : 'rgba(0,0,0,0.2)',
		'bottom'     	   : 0,
		'left'       	   : 0,
		'position'   	   : 'fixed',
		'right'      	   : 0,
		'top'        	   : 0
	});
};

SideBox.prototype.transition = function(e){
	e.preventDefault();
	var that = this;
	that.$sidebox.addClass('sidebox-'+(that.options.position === 'left' ? 'left' : 'right'));
	that.$sideboxcontent.children().detach();
	that.$sideboxcontent.append(that.$content);

	if( $('body').hasClass('sidebox-open') ) {
		that.close();
	} else {
		that.open();
	}
};

SideBox.prototype.destroy = function(){
	var that = this;
	that.$element.off('click',that.transition).data('sidebox',null);
};

register_fn('sidebox', SideBox);
},{"../lib/register-fn":25,"../lib/vendor-prefixes":26}],18:[function(require,module,exports){
'use strict';

var register_fn = require('../lib/register-fn');

function SvgTip (element, options) {
    var that = this;

    that.element = element;
    that.$element = $(element);

    that.$data = that.$element.find('.svg-tip-data').clone(),

    that.options  = $.extend({}, {
        container : 'body',
        url       : '',
        height    : 0,
        width     : 0
    }, options),

    that.load();
}

SvgTip.prototype.load = function() {
    var that = this;
    that.$element.load(that.options.url,function(e){

        var $svg = that.$element.find('svg');

        $(window).on('resize', function(){
            $svg.attr('height', that.options.height * that.$element.width() / that.options.width).attr('width', that.$element.width());
        }).trigger('resize');

        that.$data.each(function(){

            var $dataTip = $(this),

            $layer = $($dataTip.data('tip-layer')), 

            $tip;

            if( $layer.length ) {
                $layer.tooltip({
                    animation : false,
                    container : that.options.container,
                    title     : $dataTip.html(),
                    html      : true, 
                    template  : '<div class="svg-tooltip tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
                    trigger   : 'manual',
                    placement : $dataTip.data('position')
                }).mouseenter(function(){

                    $layer.tooltip('show');
                
                }).mouseleave(function(){

                    setTimeout(function(){
                        if(!$tip.hasClass('hover')) $layer.tooltip('hide');
                    },10);

                });

                $tip = $layer.data('bs.tooltip').tip().on('mouseenter',function(){

                    $tip.addClass('hover'); 

                    $layer.attr('class', function(index, classNames) {
                        return classNames + ' hover';
                    });

                }).on('mouseleave',function(){
                    
                    $layer.tooltip('hide').attr('class', function(index, classNames) {
                        return classNames.replace('hover', '');
                    }); 

                    $tip.removeClass('hover');

                });

                $dataTip.remove();
            }
        });

    });
};

register_fn('svgtip', SvgTip);
},{"../lib/register-fn":25}],19:[function(require,module,exports){
'use strict';

// require dependency
var mediaquery = require('../lib/media-query')();
var register_fn = require('../lib/register-fn');

function Timeline(el, options){

    var that = this, $data;

    that.$el = $(el);

    that.config = $.extend({}, {

        text : {
            color : '#195ecc',
            font : '18px Din',
            hover : '#f68b0f'
        },

        line : {
            color : '#40e8e8',
            width : 2
        }

    }, options),

    that.time = [];

    that.$el.find('.timeline-data').each(function() {

        $data = $(this);

        that.time.push({
            t : $data.find('.timeline-year').html(),
            c : $data.find('.timeline-content').html(),
            p : $data.find('.timeline-content').data('position')
        });

        // data.remove();

    });

    that.nodes = that.time.length;

    // console.log(that.nodes );

    that.$canvas = $('<canvas></canvas>');

    that.$el.html(that.$canvas);

    that.context = that.$canvas[0].getContext('2d');

    // console.log(that.context);

    that.resize();

    // that.hover();

    $(window).on('resize', $.proxy(that.resize, that));

}

Timeline.prototype = {

    // DeCasteljau Algorithm

    lerp : function(a, b, t) {

        return {
            x : a.x + (b.x - a.x) * t,
            y : a.y + (b.y - a.y) * t
        };

    },

    bezier : function(a, b, c, d, t) {

        var that = this,

        ab = that.lerp(a, b, t),

        bc = that.lerp(b, c, t),

        cd = that.lerp(c, d, t);

        return that.lerp(that.lerp(ab, bc, t), that.lerp(bc, cd, t), t);
    },

    slope : function(a, b) {

        return (b.y - a.y) / (b.x - a.x);

    },

    intercept : function(a, b, m) {

        return {
            x : (b.x - a.x) / i,
            y : (i * (a.x - b.x)) - b.y
        }

    },

    draw : function() {

        var that = this,

        config = that.config,

        width = that.$el.width(),

        height = that.$el.height(),

        s, e, i, points, nodes;// offset;

        if (mediaquery.breakpoint('md','max')) {

            s = {
                x : 0,
                y : 40
            };

            e = {
                x : 0,
                y : height
            };

            nodes = that.nodes + 1;

            that.drawStraightLine(s, e);

            for (i = 1; i < nodes; i++) {
                // console.log(i)
                points = {
                    x : 0,
                    y : (e.y / nodes) * i
                };

                // offset = { x : 20 }

                that.drawTime(that.time[i - 1], i, points)
            }

        } else {

            var cp1 = {
                x : Math.round(width / 1.3),
                y : Math.round(height / 1.3)
            },

            cp2 = {
                x : Math.round(width / 1.1),
                y : Math.round(height / 2.3)
            };

            s = {
                x : 0,
                y : that.$el.height() - 100
            };

            e = {
                x : width,
                y : 0
            };

            nodes = that.nodes + 2;

            that.drawCurveLine(s, cp1, cp2, e);

            for (i = 2; i < nodes; i++) {
                points = that.bezier(s, cp1, cp2, e, i
                        / ((nodes / i) * nodes));

                // offset = { y : (i%2 === 0) ? 30:-35 }

                that.drawTime(that.time[i - 2], i, points)
            }
        }

    },

    drawStraightLine : function(a, b) {

        var that = this, config = that.config;

        that.context.beginPath();

        that.context.moveTo(a.x, a.y);

        that.context.lineTo(b.x, b.y);

        that.context.strokeStyle = config.line.color;

        that.context.lineWidth = config.line.width;

        that.context.stroke();

        that.context.closePath();

    },

    drawCurveLine : function(a, b, c, d) {

        var that = this, config = that.config;

        that.context.beginPath();

        that.context.moveTo(a.x, a.y);

        that.context.bezierCurveTo(b.x, b.y, c.x, c.y, d.x, d.y);

        that.context.strokeStyle = config.line.color;

        that.context.lineWidth = config.line.width;

        that.context.stroke();

        that.context.closePath();

    },

    drawTime : function(timeprop, index, points) {

        var that = this,

        config = that.config,

        $text, $delta, delta_width, delta_height,

        offset = mediaquery.breakpoint('md','max') ? {
            x : 40
        } : {
            y : (index % 2 === 0) ? 40 : -40
        },

        arrowPos = mediaquery.breakpoint('md','max') ? 'right'
                : (index % 2 === 0 ? 'up' : 'down');

        if (timeprop.e !== undefined) {
            $text = timeprop.e.find('.text-year');

            $delta = timeprop.e.find('.delta');

            $delta.removeClass('sprite-gradient-arrow-right sprite-gradient-arrow-up sprite-gradient-arrow-down').addClass('sprite-gradient-arrow-' + arrowPos);

            delta_width = $delta.width();
            delta_height = $delta.height();

            timeprop.e.css({
                left : points.x - (delta_width / 2),
                top : points.y - (delta_height / 2),
            });
        } else {
            var $time = $('<div><div class="text-year">' + timeprop.t
                    + '</div><div class="delta sprite sprite-gradient-arrow-'
                    + arrowPos + '"></div></div>'),

            $tip, $arrow, arrowML;

            $text = $time.find('.text-year');

            $delta = $time.find('.delta');

            $time.css({
                cursor : 'pointer',
                left : points.x - (delta_width / 2),
                position : 'absolute',
                top : points.y - (delta_height / 2),
            }).on('mouseenter', function() {
                $text.css('color', config.text.hover);
            }).on('mouseleave', function() {
                $text.css('color', config.text.color);
            });

            $text.css({
                color : config.text.color,
                font : config.text.font,
                position : 'absolute',
            });

            that.$el.append($time);

            delta_width = $delta.width();
            delta_height = $delta.height();

            $time.css({
                height : delta_height,
                width : delta_width
            });

            $tip = $time.tooltip({
                placement : function() {
                    return mediaquery.breakpoint('md','max') ? 'right' : (timeprop.p === undefined ? 'top': timeprop.p);
                },
                html : true,
                title : timeprop.c,
                template : '<div style="pointer-events: none;" class="tooltip timeline-tip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
                trigger : 'hover focus click'
            }).on('shown.bs.tooltip', function(e) {

                var tipLeft = parseFloat($tip.css('left'));

                if (tipLeft < 16) {
                    $tip.css('left', 15);

                    $arrow.css('margin-left', '').css('margin-left', parseInt($arrow.css('margin-left')) - 15);

                } else if ( Math.round(tipLeft + $tip.outerWidth()) >= that.$el.outerWidth() ){
                    var offsetWidth = $tip[0].offsetWidth,
                    offsetRight = offsetWidth - parseFloat($arrow.css('left'));

                    $tip.css({
                        left : tipLeft - (parseInt($tip.find('.tooltip-inner').css('max-width')) - offsetWidth) - 15,
                        right : 15
                    });

                    $arrow.css({
                        marginLeft : '',
                        left : 'auto',
                        right : offsetRight,
                    }).css('margin-right', parseInt($arrow.css('margin-left')) - 15);

                }

            }).on('hidden.bs.tooltip', function() {

                $tip.css('right', '');

            }).data('bs.tooltip').tip();

            $arrow = $tip.find('.tooltip-arrow');

            timeprop.e = $time;
        }

        $delta.css({
            'left' : mediaquery.breakpoint('md','max') ? 10 : 0,
            'position' : 'absolute',
            'top' : 0,
        });

        $text.css({
            left : offset.x === undefined ? -(($text.width() / 2) - (delta_width / 2))
                    : offset.x,
            top : offset.y === undefined ? -(($text.height() / 2) - (delta_height / 2))
                    : offset.y
        });

    },


    resize   : function(){

        var that = this;
        // console.log( that.$el.height() );
        that.$canvas.attr({
            height : that.$el.height(),
            width  : that.$el.width()
        });

        that.clear();

        that.draw();

    },

    clear    : function(){
        this.context.clearRect(0, 0, this.$canvas.width, this.$canvas.height);
    }

};

register_fn('timeline', Timeline);
},{"../lib/media-query":24,"../lib/register-fn":25}],20:[function(require,module,exports){
'use strict';

function twitter () {
    window.twttr = (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0],
            t = window.twttr || {};
        if (d.getElementById(id)) return t;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://platform.twitter.com/widgets.js";
        fjs.parentNode.insertBefore(js, fjs); 
        t._e = [];
        t.ready = function(f) {
            t._e.push(f);
        };
        return t;
    }(document, "script", "twitter-wjs"));
}

function facebook () {
    $('body').prepend('<div id="fb-root"></div>');
    (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.6&appId=867330103299817";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
}

function pinterest () {
    (function(d){
        var f = d.getElementsByTagName('SCRIPT')[0], p = d.createElement('SCRIPT');
        p.type = 'text/javascript';
        p.async = true;
        p.src = '//assets.pinterest.com/js/pinit.js';
        f.parentNode.insertBefore(p, f);
    }(document));
}

function google () {
    (function(d){
        var f = d.getElementsByTagName('SCRIPT')[0], p = d.createElement('SCRIPT');
        p.type = 'text/javascript';
        p.async = true;
        p.src = '//apis.google.com/js/platform.js';
        f.parentNode.insertBefore(p, f);
    }(document));
}

module.exports = function () {
    // facebook();
	twitter();
    // pinterest();
    // google();
};
},{}],21:[function(require,module,exports){
'use strict';

// initialize variables and function

module.exports = function ($elements) {
	var $element = $elements;

	function resize() {
		var height = 0;
		
		$elements.each(function () {
			var $that = $(this);
			$that.css('height','auto');
			if( $that.outerHeight() > height ) height = $that.outerHeight();
			$that.css('height','');
		}).each(function () {
			$(this).css('height',height);
		});
	}

	resize();
	$(window).on('resize',resize);
}
},{}],22:[function(require,module,exports){
'use strict';

module.exports =  function() {
	return '-' + Math.random().toString(36).substr(2, 9);
};
},{}],23:[function(require,module,exports){
'use strict';

module.exports = function () {
	return (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
}
},{}],24:[function(require,module,exports){
'use strict';

// media breakpoint
var instance;

function MediaQuery (_breakpoints) {

	var that = this;

	// default breakppoints
	that.breakpoints = {
		xs : 0,
		sm : 0,
		md : 0,
		lg : 0
	};

	that.breakpoints = $.extend({},that.breakpoints,_breakpoints || {});

	var $mediaquery = $('<div class="media-query"></div>');

	$('body').append( $mediaquery );

	$.each(that.breakpoints,function(index){

		var $div = $('<div class="mq-'+index+'"></div>');

		$mediaquery.append($div); 

		that.set_breakpoint_size(index,$div.outerWidth());

	});
}

MediaQuery.prototype.set_breakpoint_size = function (breakpoint,width) { 
	this.breakpoints[breakpoint] = width;
};

MediaQuery.prototype.get_breakpoint_size = function (breakpoint) { 
	return this.breakpoints[breakpoint];
};

MediaQuery.prototype.breakpoint = function (breakpoint,range) { 
	var that = this, flag = false, screen_width = $(window).outerWidth();

	if( $.isArray(breakpoint) )
	{
		flag =  screen_width >= that.get_breakpoint_size(breakpoint[0]) && screen_width <= (that.get_breakpoint_size(breakpoint[1]) - 1);
	}
	else
	{
		if( range === 'min')
			flag =  screen_width >= that.get_breakpoint_size(breakpoint);
		else if( range === 'max')
			flag = screen_width <= (that.get_breakpoint_size(breakpoint) - 1);
	}

	return flag;
};

module.exports = function (options) {
	if ( !instance ) instance = new MediaQuery(options);

	return instance;
};
},{}],25:[function(require,module,exports){
'use strict';

module.exports = function (name, object) {
    $.fn[name] = function(options) {

        if ( this.length ) {
            return this.each(function() {
                if ( ! $.data(this, name) ) {

                    $.data( this, name, new object(this, options));

                }
            });
        }

    };

    $.fn[name].Constructor = object;
};
},{}],26:[function(require,module,exports){
'use strict';

// https://gist.github.com/paulirish/523692
module.exports = function ( prop ) {  
  var prefixes = ['Moz','Khtml','Webkit','O','ms'],
      elem     = document.createElement('div'),
      upper    = prop.charAt(0).toUpperCase() + prop.slice(1);

    if (prop in elem.style) {
        return prop;
    }

    for (var len = prefixes.length; len--; ) {
        if ((prefixes[len] + upper) in elem.style) {
            return '-' + prefixes[len].toLowerCase() + '-' + upper.toLowerCase();
        }
    }
  
    return false;   
};

},{}],27:[function(require,module,exports){
'use strict';
 
$('.hbspt-form').each(function () {
    var $that = $(this);
    $that.hbsptform($that.data());
});
},{}],28:[function(require,module,exports){
'use strict';

$('[data-toggle="magnific-popup"]').each(function () {
	var $that = $(this);
	$that.magnificPopup($that.data());
});
},{}],29:[function(require,module,exports){
'use strict';

// require dependency
var mediaquery  = require('../lib/media-query')();
var equalheight = require('../lib/equal-height');

// Navbar
var $navigation_bottom = $('#nav-bottom'),
$navigation_bottom_li_last = $navigation_bottom.find('> li.last'),
$navigation_bottom_anchors = $navigation_bottom.find('> li > a');

equalheight($navigation_bottom_anchors);

if( $navigation_bottom_li_last.hasClass('active') )
{
	$navigation_bottom.addClass('toggle-point');
}
else 
{
	$navigation_bottom.on('mouseout','> li.last',function(e) {
		if(mediaquery.breakpoint('lg','min')) $navigation_bottom.removeClass('toggle-point');
	}).on('mouseover','> li:last-child',function(e) {
		if(mediaquery.breakpoint('lg','min')) $navigation_bottom.addClass('toggle-point');
	});
}

// Dropdowns
var $dropdowns = $('.navbar-nav .dropdown');

$dropdowns.each(function(){
	var $dropdown = $(this),
	$dropdown_toggle = $dropdown.find('> .dropdown-toggle'),
	$dropdown_menu = $dropdown.find('> .dropdown-menu');

	$dropdown_toggle.on('click',function(e){
		if( mediaquery.breakpoint('md','max') && !$dropdown_menu.hasClass('in') )
		{
			e.preventDefault();
			$dropdowns.filter('.dropped').removeClass('dropped').find('> .dropdown-menu').collapse('hide');
			$dropdown.addClass('dropped');
			$dropdown_menu.collapse('show');
		}
	});
});

$(window).on('resize',function(){
	$dropdowns.removeClass('dropped');
});
},{"../lib/equal-height":21,"../lib/media-query":24}],30:[function(require,module,exports){
'use strict';

var istouchdevice = require('../lib/istouchdevice');
// $.stellar({
// 	hideDistantElements : false,
// 	// positionProperty : 'transform',
// 	responsive : true
// });

if( !istouchdevice() ) {
	skrollr.init({
		forceHeight : false
	});

	$(window).on('load', function () {
		skrollr.get().refresh();
	});
}

},{"../lib/istouchdevice":23}],31:[function(require,module,exports){
'use strict';

var $htmlbody = $('html, body'),

$scrollup = $('#scroll-up'); 

function onscroll () {
	var $section = $('[data-anchor="'+location.hash+'"]');

	if($section.length) {
	    $htmlbody.animate({
	        scrollTop: $section.offset().top
	    }, 700);
	}
}

$(window).on('hashchange load', onscroll).on('scroll',function () {
    if ($(this).scrollTop() > 100) {
        $scrollup.fadeIn();
    } else {
        $scrollup.fadeOut();
    }
});

$scrollup.on('click',function (e) {
	e.preventDefault();
    $htmlbody.animate({
        scrollTop: 0
	}, 600);
});


// $(document).ready(function() {
// 	$('html, body').animate({
// 		scrollTop: $("#pageStart").offset().top
// 	}, 600);
// 	initialLoad = false;
// });


},{}],32:[function(require,module,exports){
'use strict';

var $sidebar = $('#sidebar'),
$dropdowns = $sidebar.find('.dropdown');

$dropdowns.each(function(){
	var $dropdown = $(this),
	$dropdown_toggle = $dropdown.find('> .dropdown-toggle'),
	$dropdown_menu = $dropdown.find('> .dropdown-menu');
	//console.log($dropdowns[0]);
	$dropdown_toggle.on('click',function(e){
		if( !$dropdown_menu.hasClass('in') )
		 {
			//e.preventDefault();
			var $dropped = $dropdowns.filter('.dropped');
			$dropped.removeClass('dropped').find('> .dropdown-menu').collapse('hide');
			if( $dropped[0] !== $dropdown[0] ) {
				$dropdown.addClass('dropped');
				$dropdown_menu.collapse('show');
			}
		 }
	});
});
},{}],33:[function(require,module,exports){
'use strict';

$('[data-toggle="sidebox"]').each(function () {
	var $that = $(this);
	$that.sidebox($that.data());
});
},{}],34:[function(require,module,exports){
'use strict';
 
$('[data-toggle="svgtip"]').each(function () {
    var $that = $(this);
    $that.svgtip($that.data());
});
},{}],35:[function(require,module,exports){
'use strict';

$('[data-toggle="timeline"]').each(function () {
	var $that = $(this);
	$that.timeline($that.data());
});

$(window).trigger('resize');
},{}]},{},[14]);
